import React from "react";
import app_logo from '../../app/images/app_icon_mini.svg';

export default function EmptyState({ title, subtitle }) {
  return (
    <div className="flex flex-col items-center justify-center h-[371px] bg-white">
      <img src={app_logo} alt="Logo" className="w-[75px] h-[41px] mb-5" />
      <h2 className="text-[16px] font-bold text-gray-800 mb-1">{title}</h2>
      <p className="text-[16px] font-medium text-gray-500 max-w-[358px] text-center">{subtitle}</p>
    </div>
  );
}